import { PodcastAudio } from 'ui/components';

export const PodcastAudioFeature: React.FC<Content.PodcastAudio> = ({ content }) => (
	<PodcastAudio {...content?.properties} />
);